var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-cards",
    {
      staticClass: "full-height",
      attrs: {
        "data-test-id": "device-card",
        "is-link": "",
        "is-selected": _vm.deviceAlreadyInCartLabel !== null,
        title:
          "Découvrir " +
          _vm.currentVersion.brand +
          " " +
          _vm.currentVersion.name,
        href: _vm.currentVersion.detailLink,
        "data-oevent-category": "selecteur_produit",
        "data-oevent-action":
          "bloc_" + _vm.currentVersion.name.split(" ").join("_"),
        "data-oevent-label": _vm.currentVersion.detailLink,
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column h-100 justify-content-between" },
        [
          _c("div", { staticClass: "selector-card-upper-part" }, [
            _c("div", { staticClass: "position-absolute" }, [
              _vm.isTagIndisponible
                ? _c(
                    "div",
                    [
                      _c("ob1-tag", {
                        attrs: {
                          type: "unavailable",
                          label: _vm.model.status.label,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.currentVersion.tag
                ? _c(
                    "div",
                    [
                      _c("ob1-tag", {
                        attrs: { label: _vm.currentVersion.tag },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-row pt-2 px-1" }, [
              _c("div", { staticClass: "img-mobile mx-1" }, [
                _c(
                  "div",
                  { staticClass: "img-container" },
                  [
                    _c("selector-color-chips", {
                      attrs: { colors: _vm.model.colors },
                    }),
                    _vm._v(" "),
                    _vm.currentVersion.image
                      ? _c("ob1-picture", {
                          attrs: { visual: _vm.currentVersion.image },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infos" }, [
                _c("div", { staticClass: "mobile-infos" }, [
                  _c(
                    "h2",
                    {
                      staticClass: "no-signature standard pb-0 my-0 fw-normal",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.currentVersion.brand)
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("strong", { staticClass: "standard" }, [
                        _vm._v(_vm._s(_vm.currentVersion.name)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.currentVersion.reviews
                    ? _c(
                        "div",
                        { staticClass: "mb-1" },
                        [
                          _c("Rating", {
                            attrs: {
                              average: _vm.currentVersion.reviews.average,
                              "rating-results-height": 1.01,
                              "font-size": 0.875,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVersion.isRefurbished
                    ? _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c("ob1-capsule", {
                            attrs: {
                              label: _vm.currentVersion.refurbishedLabel,
                              "is-context": "",
                              "is-small": "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.model.status &&
                  _vm.model.status.label &&
                  !_vm.isTagIndisponible
                    ? _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c("ob1-tag", {
                            attrs: {
                              type: "unavailable",
                              label: _vm.model.status.label,
                              "is-small": "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.currentVersion.price
                  ? _c(
                      "div",
                      { staticClass: "mt-1 infos-price" },
                      [
                        _c("device-price", {
                          attrs: {
                            "multiple-price": _vm.hasMultiplePrice(
                              _vm.currentVersion.price
                            ),
                            "compact-price": true,
                            "total-price-with-promo":
                              _vm.currentVersion.price.price
                                .totalPriceWithPromo,
                            "total-price-without-promo":
                              _vm.currentVersion.price.price
                                .totalPriceWithoutPromo,
                            "monthly-amount-in-cents": _vm.currentVersion.price
                              .price.monthlyPayment
                              ? _vm.currentVersion.price.price.monthlyPayment
                                  .monthlyAmountInCents
                              : null,
                            "monthly-duration": _vm.currentVersion.price.price
                              .monthlyPayment
                              ? _vm.currentVersion.price.price.monthlyPayment
                                  .duration
                              : null,
                            "taeg-rate": _vm.currentVersion.price.price
                              .monthlyPayment
                              ? _vm.currentVersion.price.price.monthlyPayment
                                  .taegRate
                              : null,
                            "generic-label": _vm.currentVersion.price.price
                              .monthlyPayment
                              ? _vm.currentVersion.price.price.monthlyPayment
                                  .genericLabel
                              : null,
                            "loan-rate-zero-label": _vm.getLoanRateZeroLabel(
                              _vm.currentVersion.price.price
                            ),
                            "is-cents-format": true,
                            "is-price-inversion-enabled":
                              _vm.isPriceInversionEnabledForDevice(
                                _vm.currentVersion.price.price
                              ),
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.currentVersion.price && _vm.currentVersion.price.advantageValues
              ? _c(
                  "div",
                  { staticClass: "infos-advantage p-1" },
                  [
                    _c("advantage-bloc", {
                      attrs: {
                        "advantage-messages": _vm.advantageMessages,
                        "bonus-recovery":
                          _vm.currentVersion.price.advantageValues
                            .bonusRecovery,
                        discount:
                          _vm.currentVersion.price.advantageValues.discount,
                        odr: _vm.currentVersion.price.advantageValues.odr,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "cart-item-status-wrapper" }, [
              _c(
                "div",
                { staticClass: "px-1 pb-1" },
                [
                  _vm.deviceAlreadyInCartLabel
                    ? _c("ob1-message-alerte", {
                        attrs: {
                          type: "success",
                          title: _vm.deviceAlreadyInCartLabel,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }